<h2 mat-dialog-title class="dialog-title">
  <h2 class="section-title">KEY SERVICES</h2>

  <button mat-icon-button (click)="closePopUp()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="details-content">

  <div class="services-container"> 
  
  <div class="service-card" *ngFor="let service of services">
    <div class="service-title">{{ service.Service }}</div>
    <div class="service-description">
      {{ service.Description }}
    </div>
  </div>

</div>
  
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="closePopUp()">
    Close
  </button>
</mat-dialog-actions>